import './Form.css';
import _Form from './Form';
import _FormInput from './FormInput';
import _FormRadio from './FormRadio';
import _FormSelect from './FormSelect';
import _FormTextarea from './FormTextarea';
import _FormRadioGroup from './FormRadioGroup';
import _FormCheckBox from './FormCheckBox';
import _FormWrapper from './FormWrapper';
import _FormCardGroup from './FormCardGroup';
import _FormCard from './FormCard';
import _RadioValues from './RadioValues';
import _CheckboxValues from './CheckboxValues';
import _AlertForm from './AlertForm';
import _FormButton from './FormButton';
import _FormImage from './FormImage';


export const Form = _Form;
export const FormInput = _FormInput;
export const FormTextarea = _FormTextarea;
export const FormRadio = _FormRadio;
export const FormRadioGroup = _FormRadioGroup;
export const FormSelect = _FormSelect;
export const FormCheckBox = _FormCheckBox;
export const FormWrapper = _FormWrapper;
export const FormCardGroup = _FormCardGroup;
export const FormCard = _FormCard;
export const RadioValues = _RadioValues;
export const CheckboxValues = _CheckboxValues;
export const AlertForm = _AlertForm;
export const FormButton = _FormButton;
export const FormImage = _FormImage;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/index.js